// src/components/Call/AudioCall.jsx
import React, { useEffect, useState, useRef } from "react";
import { 
  getMedia, joinRoom, leaveRoom, 
  sendOffer, sendAnswer, sendCandidate, 
  onOffer, onAnswer, onCandidate 
} from "../../socket/signalingClient";
import { createPeerConnection } from "../../webrtc/peerConnection";

const AudioCall = ({ roomId, userId }) => {
  const [remoteStream, setRemoteStream] = useState(null);
  const localStreamRef = useRef(null);
  const pcRef = useRef(null);

  useEffect(() => {
    const init = async () => {
      // Get local audio
      localStreamRef.current = await getMedia(false, true);

      // Join room
      joinRoom(roomId, userId);

      // Create peer connection
      pcRef.current = createPeerConnection(roomId, setRemoteStream);

      // Add local audio track
      localStreamRef.current.getTracks().forEach(track => {
        pcRef.current.addTrack(track, localStreamRef.current);
      });

      // Handle incoming offers
      onOffer(async ({ offer, from }) => {
        await pcRef.current.setRemoteDescription(offer);
        const answer = await pcRef.current.createAnswer();
        await pcRef.current.setLocalDescription(answer);
        sendAnswer({ answer, to: from });
      });

      // Handle incoming answers
      onAnswer(async ({ answer }) => {
        await pcRef.current.setRemoteDescription(answer);
      });

      // Handle ICE candidates
      onCandidate(({ candidate }) => {
        pcRef.current.addIceCandidate(candidate);
      });
    };

    init();

    return () => {
      leaveRoom(roomId, userId);
      pcRef.current?.close();
      localStreamRef.current?.getTracks().forEach(track => track.stop());
    };
  }, [roomId, userId]);

  return (
    <div>
      <h2>Audio Call</h2>
      <audio autoPlay ref={el => el && (el.srcObject = remoteStream)} />
    </div>
  );
};

export default AudioCall;
